import { render, staticRenderFns } from "./content.vue?vue&type=template&id=f18841f8&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=f18841f8&prod&lang=less&scoped=true"
import style1 from "./content.vue?vue&type=style&index=1&id=f18841f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18841f8",
  null
  
)

export default component.exports